import Plugin from "@ckeditor/ckeditor5-core/src/plugin";

import { CkeditorConstants } from "../../src/utils";

const {
  command: {KEYWORD_UNDO_REDO},
  htmlElement: { KEYWORD_SPAN },
  operation: { UNDO, REDO },
  helperAttributes: { RESOURCE },
  htmlAttributes: { ID },
  REMOVE,
  INSERT,
} = CkeditorConstants;

export default class KeywordUndoRedo extends Plugin {
  init() {
    const {
      model: { document },
    } = this.editor;
    document.on("change:data", (_, batch) => {
      if (batch && batch.isUndo) {
        const diffItems = document.differ.getChanges({
          includeChangesInGraveyard: false,
        });
        const undoKeyword = this._getItemsByType(diffItems, REMOVE);
        const redoKeyword = this._getItemsByType(diffItems, INSERT);
        let operation = null;
        if (undoKeyword.length) {
          operation = UNDO;
        } else if (redoKeyword.length) {
          operation = REDO;
        }
        (redoKeyword.length || undoKeyword.length) &&
          this.editor.fire(KEYWORD_UNDO_REDO, {
            operation,
            keywordToUndo: undoKeyword,
            keywordToRedo: redoKeyword
          });
      }
    });
  }

  _map(items) {
    return items.map((item, _) => ({
      keywordId: item.attributes.get(RESOURCE).split("/").pop(),
      docReferenceId: item.attributes.get(ID),
    }));
  }

  _getItemsByType(diffItems, type) {
    return this._map(
      diffItems.filter(
        (diffItem) => diffItem.type === type && diffItem.name === KEYWORD_SPAN
      )
    );
  }
}
